module.exports = __webpack_public_path__ + "img/ic_ssl.6f42f5f4.svg";